import { ServerActionResult } from '../types';
import { getErrorMessageFromAnyErrorLike } from '@/src/lib/utils/error';

export function success<T>(data: T): ServerActionResult<T, null> {
  return {
    ok: true,
    data,
    error: null,
  };
}

export function failure<E>(error: E): ServerActionResult<null, E | string> {
  const errorMessage = getErrorMessageFromAnyErrorLike(error);
  let err: string;
  
  if (typeof errorMessage === 'string') {
    err = errorMessage;
  } else {
    err = JSON.stringify(errorMessage);
  }
  
  return {
    ok: false,
    data: null,
    error: err,
  };
}

export function isFailure<E>(result: ServerActionResult<unknown, unknown>): result is ServerActionResult<null, E> {
  return !result.ok;
}
